import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, SupplierInvoiceFee } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierInvoiceFeeService {
  apiService: ApiHttpService<SupplierInvoiceFee> = inject(ApiHttpService<SupplierInvoiceFee>);

  getSupplierInvoiceFeeByIri(iri: string): Observable<SupplierInvoiceFee> {
    return this.apiService.get(iri).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoiceFee>) => result.body),
    );
  }

  getSupplierInvoiceFeeById(id: string): Observable<SupplierInvoiceFee> {
    return this.apiService.get(`/supplier_invoice_fees/${id}`).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoiceFee>) => result.body),
    );
  }

  getSupplierInvoiceFeesForSupplierInvoice(iri: string): Observable<SupplierInvoiceFee[]> {
    return this.apiService.getMany(`${iri}/supplier_invoice_fees`).pipe(map((result) => result.body['hydra:member']));
  }

  createSupplierInvoiceFee(supplierInvoiceFee: SupplierInvoiceFee): Observable<SupplierInvoiceFee> {
    return this.apiService
      .post(`/supplier_invoice_fees`, supplierInvoiceFee)
      .pipe(map((result: CustomHttpResponse<SupplierInvoiceFee>) => result.body));
  }

  updateSupplierInvoiceFee(
    iri: string,
    updatedRecord: Record<string, string | number | null | undefined>,
  ): Observable<SupplierInvoiceFee> {
    return this.apiService.patch(iri, updatedRecord as unknown as SupplierInvoiceFee).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoiceFee>) => result.body),
    );
  }

  delete(iri: string) {
    return this.apiService.delete(iri).pipe(map((result) => result));
  }
}
